import type { dashboardSidebarProps } from "./types.props";
import styles from "./DashboardSidebar.module.css";

const DashboardSidebar: React.FC<dashboardSidebarProps> = ({
    selectedSimulation,
    activeSection,
    navItems,
    globalScore: globalTemp,
    percentile: percentileTemp,
    onNavigate,
}) => {
    const globalScore = selectedSimulation?.summary?.globalScore || globalTemp;
    const percentile = selectedSimulation?.summary?.percentile || percentileTemp;

    return (
        <div className={styles.sidebarContainer}>
            <div className={styles.headerBlock}>
                <div className={styles.scoreRow}>
                    <div className={styles.globalScore}>
                        {globalScore > 0 ? globalScore : "---"}
                    </div>
                    <div className={styles.scoreLabel}>PUNTAJE GLOBAL</div>
                    {percentile !== undefined && percentile > 0 ? (
                        <div className={styles.percentile}>
                            Percentil: <strong>{percentile}</strong>
                        </div>
                    ) : (
                        false
                    )}
                </div>
            </div>

            <nav className={styles.nav} aria-label="Secciones del reporte">
                <ul className={styles.navList}>
                    {navItems.map((item) => (
                        <li key={item.id} className={styles.navItem}>
                            <button
                                type="button"
                                onClick={() => onNavigate(item.id)}
                                className={`${styles.navButton} ${activeSection === item.id ? styles.active : ""
                                    }`}
                            >
                                <span className={styles.icon} aria-hidden="true">
                                    {item.icon}
                                </span>
                                {item.label}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
};

export default DashboardSidebar;
